module.exports = __webpack_public_path__ + "img/avatar1.715e85bb.png";